import { useId } from "react";

export const BOARD_SIZE = 500;
export const SVG_SIZE = 1536;

const gridCoordBadgeBase = {
    position: "absolute",
    top: 1,
    left: 1,
    padding: "0 1px",
    lineHeight: 1,
    fontFamily: "ui-monospace, monospace",
    fontWeight: 600,
    color: "#fff",
    background: "rgba(0,0,0,0.72)",
    borderRadius: 1,
    pointerEvents: "none",
    zIndex: 2,
};

function gridCoordBadgeStyle(cellPx) {
    return {
        ...gridCoordBadgeBase,
        fontSize: Math.max(5, Math.min(7, Math.round(cellPx * 0.085))),
    };
}

/** Copy of pages jigsaw PieceVisual for isolated admin canvas tests. */
export function PieceVisual({ pieceIndex, imageUrl, grid, paths, showGridCoords = false }) {
    const uid = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    const cellSvg = SVG_SIZE / grid;
    const cellPx = BOARD_SIZE / grid;
    const col = pieceIndex % grid;
    const row = Math.floor(pieceIndex / grid);
    const pieceData = paths[pieceIndex];
    const clipId = `tjcp${uid}g${grid}p${pieceIndex}`;
    const margin = cellSvg * 0.35;
    const vbSpan = cellSvg + margin * 2;
    const renderSize = (vbSpan / cellSvg) * cellPx;
    const offset = (margin / vbSpan) * renderSize;

    return (
        <div style={{ position: "relative", width: cellPx, height: cellPx }}>
            <svg
                width={renderSize}
                height={renderSize}
                viewBox={`${col * cellSvg - margin} ${row * cellSvg - margin} ${cellSvg + margin * 2} ${cellSvg + margin * 2}`}
                style={{ position: "absolute", left: -offset, top: -offset }}
                overflow="visible"
            >
                <defs>
                    <clipPath id={clipId}>
                        <path d={pieceData.path} />
                    </clipPath>
                </defs>
                <image
                    href={imageUrl}
                    x="0"
                    y="0"
                    width={SVG_SIZE}
                    height={SVG_SIZE}
                    preserveAspectRatio="xMinYMin slice"
                    clipPath={`url(#${clipId})`}
                />
            </svg>
            {showGridCoords && grid > 0 && (
                <span style={gridCoordBadgeStyle(cellPx)}>
                    ({col},{row})
                </span>
            )}
        </div>
    );
}
